import { ISettings } from './types';

export const validateSettings = (settings: Partial<ISettings>) => {
  let valid = true;
  type SettingsKey = keyof ISettings;
  const validateFunctions: Partial<Record<SettingsKey, (val: any) => boolean>> = {
    reminderInterval: validateReminderInterval,
    onboarding: () => true,
  };

  for (const key of Object.keys(settings) as SettingsKey[]) {
    const validate = validateFunctions[key];
    if (!validate) {
      valid = false;
    } else {
      valid = valid && validate(settings[key]);
    }
  }

  return valid;
};

const validateReminderInterval = (values: number[]) => {
  let valid = true;
  const validValues = [14, 30];

  for (const value of values) {
    valid = valid && validValues.includes(value);
  }

  return valid;
};
